/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface EnableMaintenanceModeRequestDto
 */
export interface EnableMaintenanceModeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof EnableMaintenanceModeRequestDto
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnableMaintenanceModeRequestDto
     */
    ignoreLoggedInUsers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnableMaintenanceModeRequestDto
     */
    $type?: EnableMaintenanceModeRequestDtoTypeEnum;
}


/**
 * @export
 */
export const EnableMaintenanceModeRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedSystemComponentDtoEnableMaintenanceModeRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.SystemComponent.Dto.EnableMaintenanceModeRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnableMaintenanceModeRequestDtoTypeEnum = typeof EnableMaintenanceModeRequestDtoTypeEnum[keyof typeof EnableMaintenanceModeRequestDtoTypeEnum];



/**
 * Check if a given object implements the EnableMaintenanceModeRequestDto interface.
 */
export function instanceOfEnableMaintenanceModeRequestDto(value?: unknown): value is EnableMaintenanceModeRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnableMaintenanceModeRequestDtoTypeEnum)[0];
}

export function EnableMaintenanceModeRequestDtoFromJSON(json: any): EnableMaintenanceModeRequestDto {
    return EnableMaintenanceModeRequestDtoFromJSONTyped(json, false);
}

export function EnableMaintenanceModeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableMaintenanceModeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'ignoreLoggedInUsers': json['ignoreLoggedInUsers'] == null ? undefined : json['ignoreLoggedInUsers'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnableMaintenanceModeRequestDtoToJSON(value?: EnableMaintenanceModeRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'password': value['password'],
        'ignoreLoggedInUsers': value['ignoreLoggedInUsers'],
        '$type': value['$type'],
    });
}

